/* On the PDP, media[0] is always DAY and media[1] is always EVENING (see the
   brief's fixed image-order standard). Dawn's <media-gallery> always renders
   featured_media (= media[0] unless a variant overrides it) as the visible
   slide, so on load — and whenever the theme toggles or a variant change
   makes Dawn re-render the gallery back to its own default — we re-apply
   whichever of the two the current theme calls for. No page reload, and this
   never touches variant selection: it only swaps which media slide is active. */
(function () {
  'use strict';

  function currentTheme() {
    return document.documentElement.getAttribute('data-ticho-theme') === 'evening' ? 'evening' : 'day';
  }

  function applyToGallery(gallery) {
    var dayId = gallery.dataset.tichoDayMedia;
    var eveningId = gallery.dataset.tichoEveningMedia;
    if (!eveningId) return; // no Evening photo on this product — stay on the single/Day image, nothing to swap

    var targetId = currentTheme() === 'evening' ? eveningId : dayId;
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetId, false);
    }
  }

  function applyToAllGalleries() {
    document.querySelectorAll('media-gallery[data-ticho-evening-media]').forEach(applyToGallery);
  }

  document.addEventListener('ticho:themechange', applyToAllGalleries);

  // Dawn's product-info fetches fresh section HTML on variant change and swaps
  // the whole gallery markup back in, which resets the active slide to that
  // variant's own featured_media — re-apply our Day/Evening choice right after.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(applyToAllGalleries, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyToAllGalleries);
  } else {
    applyToAllGalleries();
  }
})();
